import { useEffect, useState } from 'react'
import { useTrivia } from '../../contexts/trivia-context'
import PreferencesPicker from './pref-picker'
import TriviaList from './trivia-list'
import IntroductionTrivia from './components/introduction'

const Trivia = () => {
  const [trivia] = useTrivia()
  const [showIntroduction, setShowIntroduction] = useState(THEME_CONFIG?.trivia?.showIntroduction)
  const introductionTrivia = localStorage.getItem('introductionTrivias') === 'true'

  useEffect(() => {
    console.log(THEME_CONFIG.trivia)

    const event = new CustomEvent('background-color', {
      detail: {
        shouldUseWhiteBg: true,
        from: 'trivias page load'
      }
    })

    window.dispatchEvent(event)
  }, [])

  if (showIntroduction && !introductionTrivia) {
    return <IntroductionTrivia setShowIntroduction={setShowIntroduction} />
  }

  if (!trivia.interests.length && THEME_CONFIG.trivia?.interestsRequired) {
    return <PreferencesPicker />
  }

  return <TriviaList />
}

export default Trivia
